import * as React from 'react';
import { ISeedProduct, ISeedAttributeValue, ISeedAttribute } from '../../infrastructure/interfaces';
import { AgronomyChartPosition, SeedCategory } from 'src/infrastructure/enums';
import './styles/TypeSeedAgronomy.css';
import { isDynaGro } from 'src/config';

export interface ITypeSeedAgronomy {
  product: ISeedProduct;
  first: boolean;
  last: boolean;
  zebra: string;
  pageNumber?: number;
}


export default class TypeSeedAgronomy extends React.Component<ITypeSeedAgronomy> {

  constructor(props: ITypeSeedAgronomy) {
    super(props);
  }

  componentDidMount() {
  }

  componentWillReceiveProps() {
  }

  render() {
    const {
      category: {
        id: categoryId,
      },
    } = this.props.product;
    const classNames = [
      'page-drop',
      'seed',
      `seed-category-${categoryId}`,
      'agronomy',
      this.props.zebra,
      this.props.product.isNew ? 'new-seed' : '',
    ];
    const attriubutesPerSide: ISeedAttribute[][] = [];
    this.attributesPerCategory().forEach((attribute: ISeedAttribute) => {
      if (attribute && attribute.agronomyChartPosition) {
        if (typeof attriubutesPerSide[attribute.agronomyChartPosition] === 'undefined') {
          attriubutesPerSide[attribute.agronomyChartPosition] = [];
        }
        attriubutesPerSide[attribute.agronomyChartPosition].push(attribute);
      }
    });
    const leftCount: number = (attriubutesPerSide[AgronomyChartPosition.Left] && attriubutesPerSide[AgronomyChartPosition.Left].length || 0) + 1;
    const rightCount: number = (attriubutesPerSide[AgronomyChartPosition.Right] && attriubutesPerSide[AgronomyChartPosition.Right].length || 0) + 1;
    return (
      <div className={classNames.join(' ')}>
        {this.props.first && (
          <div className="agronomy-labels">
            <div className={`labels-left item-count-${leftCount}`}>
              <div className="agronomy-product-label"><span>{this.getBrandLabel()}</span></div>
              {attriubutesPerSide[AgronomyChartPosition.Left] && this.renderLabels(attriubutesPerSide[AgronomyChartPosition.Left])}
            </div>
            <div className={`labels-right item-count-${rightCount}`}>
              {attriubutesPerSide[AgronomyChartPosition.Right] && this.renderLabels(attriubutesPerSide[AgronomyChartPosition.Right])}
              <div className="agronomy-product-label"><span>{this.getBrandLabel()}</span></div>
            </div>
          </div>
        )}
        <div className="drop-content">
          <div className={`values-left item-count-${leftCount}`}>
            <div className="agronomy-product-label">{this.props.product.name}</div>
            {attriubutesPerSide[AgronomyChartPosition.Left] && this.renderValues(attriubutesPerSide[AgronomyChartPosition.Left])}
          </div>
          <div className={`values-right item-count-${rightCount}`}>
            {attriubutesPerSide[AgronomyChartPosition.Right] && this.renderValues(attriubutesPerSide[AgronomyChartPosition.Right])}
            <div className="agronomy-product-label">{this.props.product.name}</div>
          </div>
        </div>
        {this.props.last && (<div className="agronomy-legend">Bold = New product</div>)}
      </div>
    );
  }

  renderLabels(attributes: ISeedAttribute[]): JSX.Element[] {
    return attributes.map((attribute: ISeedAttribute) => (
      <div className={`agronomy-label agronomy-attribute-${attribute.name}`} key={attribute.name}><span>{this.attributeName(attribute.name)}</span></div>
    ));;
  }

  renderValues(attributes: ISeedAttribute[]): JSX.Element[] {
    return attributes.map((attribute: ISeedAttribute) => (
      <div className={`agronomy-value agronomy-attribute-${attribute.name}`} key={attribute.name}>{this.attributeValue(attribute.name)}</div>
    ));
  }

  attributesPerCategory(): ISeedAttribute[] {
    const attributeNames: ISeedAttribute[] = [];
    this.props.product.attributes.forEach((attrData: ISeedAttributeValue) => {
      const attribute = attrData.attribute;
      if (attribute.agronomyChartDisplayName && attribute.agronomyChartIndex !== null && attribute.agronomyChartPosition) {
        attributeNames[attribute.agronomyChartIndex] = attribute;
      }
    });
    return attributeNames;
  }

  attributeValue(name: string|string[], delimiter: string = ''): string {
    const {
      attributes,
    } = this.props.product;
    const value: string[] = [];
    const names: string[] = typeof name === 'string' ? [name] : name;
    attributes.forEach((attrData: ISeedAttributeValue) => {
      if (names.includes(attrData.attribute.name)) {
        value.push(attrData.value);
      }
    });
    return value.join(delimiter);
  }

  attributeName(name: string|string[]): string {
    let title = '';
    const findName: string = typeof name === 'string' ? name : name[0];
    this.props.product.attributes.forEach((attrData: ISeedAttributeValue) => {
      const attribute = attrData.attribute;
      if (attribute.name === findName) {
        title = attribute.agronomyChartDisplayName ||
          attribute.productDescriptionDisplayName ||
          attribute.createSeedDisplayName;
      }
    });
    return title;
  }

  getBrandLabel() {
    const {
      product: {
        category: {
          id: categoryId,
        }
      }
    } = this.props;
    switch (categoryId) {
      case SeedCategory.Alfalfa:
      case SeedCategory.Corn:
      case SeedCategory.Silage:
      case SeedCategory.Cotton:
      case SeedCategory.GrainSorghum:
      case SeedCategory.HardRedSpringWheat:
      case SeedCategory.HardRedWinterWheat:
      case SeedCategory.SoftRedWinterWheat:
      case SeedCategory.SoftWhiteWinterWheat:
      case SeedCategory.SoybeansOver3_5RM:
      case SeedCategory.SoybeansUnder3_5RM:
      case SeedCategory.Rice:
        return isDynaGro() ? 'Dyna-Gro Brand' : 'Proven Brand';
      default:
        return 'Brand';
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/Products/TypeSeedAgronomy.tsx